import { useMemo } from 'react';
import styled from 'styled-components';

import { Country } from '@dreryk/address-common-api';

import { commonTranslationKeys, FormContextValues, ValidationRules } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { CountriesSelectList, getCountryDisplayValue } from '~libs.desktop.shared.fields';

import { MedicalLeaveCommonFormsBean } from '../../common.types';

export type CountryFieldProps = Pick<FormContextValues<MedicalLeaveCommonFormsBean>, 'register'>;

const StyledSelect = styled(Select)`
   grid-area: country;
` as typeof Select;

export const CountryField = (props: CountryFieldProps): JSX.Element => {
   const validationRules = useMemo<ValidationRules<MedicalLeaveCommonFormsBean>>(() => {
      return {
         required: true,
      };
   }, []);

   return (
      <StyledSelect<Country>
         testId={'country'}
         triggerLabelExtractor={getCountryDisplayValue}
         placeholder={commonTranslationKeys.choose}
         controller={props.register('address.country', validationRules)}
         label={commonTranslationKeys.addressData.country}
         maxHeight={190}
         searchInputEnabled
      >
         <CountriesSelectList />
      </StyledSelect>
   );
};
